import get from 'lodash/get'

const translateSearchRequest = searchRequest => {
  let [
    departingFrom,
    returningFrom,
    travelDate,
    returnDate,
    origin,
    destination,
  ] = [null, null, '', '']

  const sliceMatches = searchRequest.slicesURL.match(
    new RegExp(/(\w{3}-\w{3}-\d{8})/g)
  )

  const { slices, airports } = searchRequest
  if (slices && slices.length && airports) {
    // Get the params from url
    origin = slices[0].originAirport
    destination =
      slices.length > 1
        ? slices[slices.length - 1].originAirport
        : slices[0].destinationAirport

    // Get the data from params
    const originData = airports[origin]
    const destinationData = airports[destination]

    // Get the Departure Date
    travelDate = slices[0].travelDate
    returnDate = get(slices, '[1].travelDate', '')

    departingFrom = {
      cityCode: originData.cityCode,
      airportCode: originData.airportCode,
      cityName: originData.cityName,
    }
    returningFrom = {
      cityCode: destinationData.cityCode,
      airportCode: destinationData.airportCode,
      cityName: destinationData.cityName,
    }
  }

  // Travelers
  const travelers = Object.keys(searchRequest.params).reduce((acc, cur) => {
    const match = cur.match(new RegExp(/^num-(\w+)$/))

    if (match) {
      acc[match[1]] = parseInt(searchRequest.params[cur], 10)
    }

    return acc
  }, {})

  // default to 1 adult and the rest of travelers to 0 if they don't exist in searchRequest
  if (!travelers.adults) {
    travelers.adults = 1
  }

  if (!travelers.youths) {
    travelers.youths = 0
  }

  if (!travelers.infants) {
    travelers.infants = 0
  }

  if (!travelers.children) {
    travelers.children = 0
  }

  // TODO: GET this from Search Request
  // Trip type
  let tripType = 'MD'

  if (
    slices.length === 2 &&
    slices[0].originAirport === slices[1].destinationAirport &&
    slices[1].originAirport === slices[0].destinationAirport
  ) {
    tripType = 'RT'
  } else if (searchRequest.slices.length < 2) {
    tripType = 'OW'
  }

  return {
    airports,
    slices: sliceMatches || [],
    cabinClass: searchRequest.params['cabin-class'],
    travelers,
    tripType,
    departingFrom,
    returningFrom,
    travelDate,
    returnDate,
    origin,
    destination,
  }
}

export { translateSearchRequest }
